import { type FC } from 'react'

import {
  ACTIONS,
  DESCRIPTIONS,
  ERROR_MESSAGES,
  MENU,
  SUCCESS_MESSAGES
} from '@/constants/common/message.constants'
import { createTariffImportJob } from '@/features/tariff-import-jobs/api'
import { validateExcelFile } from '@/utils/upload-file-validator'

import { isOpenTariffImportModalAtom } from '../../-states'
import { CsvImportModal } from '../CsvImportModal/CsvImportModal'

type Props = {
  tenantKey: string
}

/**
 * タリフインポートModal
 */
export const TariffImportModal: FC<Props> = ({ tenantKey }) => {
  return (
    <CsvImportModal
      tenantKey={tenantKey}
      isOpenAtom={isOpenTariffImportModalAtom}
      modalTitle={MENU.IMPORTING_TARIFF}
      draggerTitle={ACTIONS.UPLOAD_TARIFF}
      draggerDescription={<>{DESCRIPTIONS.UPLOAD_TARIFF}</>}
      isValidFile={validateExcelFile}
      createImportJob={(formValue, dcId) =>
        createTariffImportJob({ tenantKey, dto: { ...formValue, dcId } })
      }
      successMessage={SUCCESS_MESSAGES.STARTED_TARIFF_IMPORT}
      errorMessage={ERROR_MESSAGES.FAILED_TO_START_TARIFF_IMPORT}
      historyRoute="/$tenantKey/settings/tariff-import-jobs"
    />
  )
}
